/**
 * @documental
 * @export Strikethrough
 * @type
 * typographyComponent
 * @use
 * The `Strikethrough` component should be used to identify text content which has been deleted or is incorrect.
 * @element
 * s
 * @className
 * strikethrough
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { createComponentStyleHook } from "../../tokens";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import tokenStyles from "./styles.module.css";

/**
 * The Strikethrough component properties.
 */

export interface StrikethroughProps extends BaseProps {}

const useResolvedStrikethroughStyles = createComponentStyleHook<StrikethroughProps>({
  legacyStyles: () => import("./styles.module.scss"),
  tokenStyles,
  componentTokens: "strikethrough",
});

/**
 * Specifies that text content should be displayed as having a strike through line. Can be overridden
 * through the use of the [Underlined](../Underlined/README.md) component.
 */
export const Strikethrough: FC<PropsWithChildren<StrikethroughProps>> = (props) => {
  const { children } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedStrikethroughStyles(props);
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Strikethrough, "strikethrough"] });

  return (
    <StyleModeBoundary mode={mode}>
      <s {...baseHtmlProps}>{children}</s>
    </StyleModeBoundary>
  );
};
